var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHB2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 629,
    height: 510,
    viewBox: "0 0 629 510",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_1_860)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M412.668 249.866C412.668 304.651 366.852 302.016 310.334 302.016C253.817 302.016 208 304.651 208 249.866C208 195.081 253.817 150.668 310.334 150.668C366.852 150.668 412.668 195.081 412.668 249.866Z",
    fill: "#21CAE1"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_1_860)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M420.604 244.198C420.604 298.983 374.788 302.016 318.27 302.016C261.752 302.016 215.936 298.983 215.936 244.198C215.936 189.412 261.752 145 318.27 145C374.788 145 420.604 189.412 420.604 244.198Z",
    fill: "#21CAE1"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_1_860",
    x: 0.490112,
    y: -56.8414,
    width: 619.688,
    height: 566.387,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 103.755,
    result: "effect1_foregroundBlur_1_860"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_1_860",
    x: 8.42592,
    y: -62.5099,
    width: 619.688,
    height: 572.035,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 103.755,
    result: "effect1_foregroundBlur_1_860"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHB2);
export default __webpack_public_path__ + "static/media/h-b-2.5d307a1209537c20ce6cccf00bc4f337.svg";
export { ForwardRef as ReactComponent };